<template>
  <div id="side-bar">
    <b-list-group flush class="no-border">
      <!-- :::::::::::::::::::::::::::: MENU RETORNAR SGCQ :::::::::::::::::::::::::::: -->
      <b-list-group-item class="menu-top border-bottom">
        <img
          id="logo"
          class="m-2"
          :src="require('/static/images/logo_sgcq_w.png')"
          aria-label="Logomarca do SGCQ"
          width="130"
          @click="display()"
        />
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU LIST :::::::::::::::::::::::::::: -->
      <b-list-group-item class="menu-top border-bottom">
        <b-icon icon="slack" animation="spin" class="mr-3" /> Menu de Opções
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU LISTA DE ORCAMENTOS :::::::::::::::::::::::::::: -->
      <b-list-group-item class="menu-top border-bottom">
        <p class="m-1">Filtro:</p>
        <b-form-select v-model="status">
          <b-form-select-option v-for="option of options" v-bind:key="option.id" :value="option.value"
            >{{ option.text }}
          </b-form-select-option>
        </b-form-select>
        <b-form-input type="search" class="mt-2" placeholder="Descrição" v-model="descricao" />
        <b-form-input type="search" class="mt-2" placeholder="Cliente" v-model="cliente" />
        <b-form-input type="search" class="mt-2" placeholder="Solicitante" v-model="solicitante" />
      </b-list-group-item>
      <b-list-group-item class="menu-top">
        <b-form-datepicker button-only></b-form-datepicker>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";

export default {
  name: "SideBarDoDashboardPrioridade",

  data() {
    return {
      status: "atendida",
      descricao: "",
      cliente: "",
      solicitante: "",
      filtro: {
        descricao: "",
        solicitante: "",
        cliente: "",
      },
      options: [
        { id: 1, value: "não excluir", text: "não excluir" },
        { id: 2, value: "não atendida", text: "não atendida" },
        { id: 3, value: "parcialmente atendida", text: "parcialmente atendida" },
        { id: 4, value: "atendida", text: "atendida" },
      ],
    };
  },

  watch: {
    status: function (status) {
      this.$emit("sorted", status);
    },
    descricao: function (descricao) {
      this.filtro.descricao = descricao;
      this.$emit("filtrar", this.filtro);
    },
    cliente: function (cliente) {
      this.filtro.cliente = cliente;
      this.$emit("filtrar", this.filtro);
    },
    solicitante: function (solicitante) {
      this.filtro.solicitante = solicitante;
      this.$emit("filtrar", this.filtro);
    },
  },

  methods: {
    display() {
      this.$router.push({ path: "/sgcq" });
    },
  },

  setup() {
    const store = useSgcqStore();

    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped>
#side-bar {
  display: inline-block;
  width: 20%;
  height: 99vh;
  background-color: #112a4a;
  overflow: scroll;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  left: 0;
  text-align: start;
}

.menu-top {
  background-color: #112a4a;
  color: #fff;
  border: none;
}
</style>
